import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar, Footer } from './components/components';
import { Home, About, Contact } from './pages/pages';
import { Certification, ITSolutions, Energy } from './pages/services/services';
import { BISSchemeIProducts } from './pages/services/bisSchemeI';

// GA4 only auto-fires a page_view on the very first load. Since this is a
// React Router SPA, every subsequent client-side navigation needs its own
// page_view event sent manually, or GA4 will only ever see one pageview
// per visit no matter how many routes the user visits.
function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
        page_location: window.location.href,
      });
    }
  }, [location]);
}

function AppRoutes() {
  usePageTracking();
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/certification" element={<Certification />} />
        <Route path="/services/certification/products-under-compulsory-certification" element={<BISSchemeIProducts />} />
        <Route path="/services/it-solutions" element={<ITSolutions />} />
        <Route path="/services/energy" element={<Energy />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;